import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Pagination } from '../../features/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const InvestProjects = () => {
  const [projects, setProjects] = useState({ items: [], totalCount: 0 });
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const getData = async (count = 20, offset = 0) => {
    try {
      setLoading(true);
      const response = await apiRequests.investProjects.get(searchValue, count, offset);
      setProjects(response);
    } catch (e) {
      console.error('Ошибка загрузки проектов:', e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    getData();
  };

  const handleDelete = (id) => {
    apiRequests.investProjects.delete(id).then(() =>
      setProjects((prev) => ({
        totalCount: prev.totalCount - 1,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск по названию..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {loading ? (
          <p className="text-center">Загрузка...</p>
        ) : projects.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          projects.items?.map((project) => (
            <EntityCard
              key={project.id}
              image={project.imageURL}
              title={project.title}
              editLink={`${location.pathname}/${project.id}`}
              localizationLink={`${location.pathname}/${project.id}/localization`}
              onDelete={() => handleDelete(project.id)}
            />
          ))
        )}
      </div>

      {projects.totalCount > 20 && (
        <Pagination
          count={projects.totalCount}
          itemsPerPage={20}
          onChange={(page) => getData(20, 20 * page)}
        />
      )}
    </>
  );
};

export default InvestProjects;
